import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SupplierContactType } from '../models/masterdata.model';
import { Language, SupplierContactPropertyValue, SupplierContact, Supplier, SupplierEntityPropertyValues, SupplierDocument, EmailDomainPropertyValue, EmailDomain, MfaDeclinedReasons } from '../models/supplier.model';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { SupplierEvent } from '../models/generic.model';
import { ValidationTask } from '../models/people.model';
import { AppSettings } from '../../app.settings';
import { SupplierTaskDetail } from '../models/suppliertasks.model';

@Injectable()
export class ContactsService extends BaseService {
    protected _supplierContactTypes: SupplierContactType[];
    protected _languages: Language[];
    private _supplierContactItems: SupplierContactPropertyValue[];
    constructor(private http: HttpClient,
        private config: AppSettings,) {
        super();
    }

    processContactChange(supplierCode: string, contacts: SupplierContact[], documents: SupplierDocument[] = null): Observable<SupplierEvent> {
        var event: SupplierEvent = new SupplierEvent();
        event.Name = "Contact Change Requested";
        event.ReferenceIdentifier = supplierCode;
        var supplierDetails: Supplier = new Supplier();
        supplierDetails.Contacts = contacts;
        if (documents) {
            supplierDetails.Documents = documents;
        }
        event.Properties = supplierDetails;
        return this.http.post<SupplierEvent>(`${this.config.BaseUrl}Profile/${supplierCode}/Event`, event, { headers: this.setHeaders() });
    }

    processMFADeclinedReasons(supplierCode: string, declineReasons: MfaDeclinedReasons): Observable<SupplierEvent> {
        var event: SupplierEvent = new SupplierEvent();
        event.Name = "MFA ENROLLMENT DECLINED";
        event.ReferenceIdentifier = supplierCode;
        event.Properties = declineReasons;
        return this.http.post<SupplierEvent>(`${this.config.BaseUrl}Profile/${supplierCode}/Event`, event, { headers: this.setHeaders() });
    }

    processContactAndDomainChange(supplierCode: string, contacts: SupplierContact[], documents: SupplierDocument[] = null, emailDomain: EmailDomain[]): Observable<SupplierEvent> {
        var event: SupplierEvent = new SupplierEvent();
        event.Name = "Contact Change Requested";
        event.ReferenceIdentifier = supplierCode;
        var supplierDetails: Supplier = new Supplier();
        supplierDetails.Contacts = contacts;
        if (documents) {
            supplierDetails.Documents = documents;
        }
        supplierDetails.Domains = emailDomain;
        event.Properties = supplierDetails;
        return this.http.post<SupplierEvent>(`${this.config.BaseUrl}Profile/${supplierCode}/Event`, event, { headers: this.setHeaders() });
    }

    processEmailDomainChange(supplierCode: string, domains: EmailDomain, documents: SupplierDocument = null): Observable<SupplierEvent> {
        var event: SupplierEvent = new SupplierEvent();
        event.Name = "Email Domain Change Requested";
        event.ReferenceIdentifier = supplierCode;
        var supplierDetails: Supplier = new Supplier();
        supplierDetails.Domains = [domains];
        if (documents) {
            supplierDetails.Documents = [documents];
        }
        event.Properties = supplierDetails;
        return this.http.post<SupplierEvent>(`${this.config.BaseUrl}Profile/${supplierCode}/Event`, event, { headers: this.setHeaders() });
    }

    GetSupplierContactListByCode(supplierCode: string): Observable<SupplierContactPropertyValue[]> {

        return this.http.get<any>(`${this.config.BaseUrl}Profile/supplierinformation/` + supplierCode + '/contact', { headers: this.setHeaders() })
            .pipe(map(res => {
                return res && res.contacts ? res.contacts : null
            }));
    }

    getSupplierPendingTasksByCode(supplierCode: string): Observable<SupplierTaskDetail[]> {

        return this.http.get<any>(`${this.config.BaseUrl}Profile/Onboarding/GetPendingTasks/` + supplierCode, { headers: this.setHeaders() })
            .pipe(map(res => {
                return res ? res : null
            }));
    }

    getEmailDomainByCode(supplierCode: string): Observable<EmailDomainPropertyValue[]> {
        return this.http.get<any>(`${this.config.BaseUrl}Profile/supplierinformation/` + supplierCode + '/domain', { headers: this.setHeaders() })
            .pipe(map(res => {
                return res && res.domains ? res.domains : null
            }));
    }


    getEntityListByCode(supplierCode: string): Observable<SupplierEntityPropertyValues[]> {
        return this.http.get<any>(`${this.config.BaseUrl}Profile/supplierinformation/` + supplierCode + '/entity', { headers: this.setHeaders() })
            .pipe(map(res => {
                return res && res.entities ? res.entities : null
            }));
    }
    GetValidationTaskByCode(supplierCode: string): Observable<ValidationTask> {

        return this.http.get<any>(`${this.config.BaseUrl}Profile/` + supplierCode + '/ValidationTask', { headers: this.setHeaders() })
            .pipe(map(res => {
                return res;
            }));
    }

    GetRejectionComments(supplierCode: string): Observable<any> {

        return this.http.get<any>(`${this.config.BaseUrl}Profile/` + supplierCode + '/ContactChangesRejection', { headers: this.setHeaders() })
            .pipe(map(res => {
                return res;
            }));
    }



    get supplierContactItems(): SupplierContactPropertyValue[] {
        return this._supplierContactItems;
    };

    set supplierContactItems(val) {
        this._supplierContactItems = val;
    };
}

